export default __webpack_public_path__ + "static/media/Acolyte's Gloves of the Hallow Worlds.7e5d1f18.jpg";